import {
  IAlarmCentralProps,
  IZoneAlarmCentralProps,
} from '../../../../../services/AlarmCentralService/types';
import { Grid2, Typography } from '@mui/material';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import './AlarmCentralPhysical.css';
import {
  useSendBypassZones,
  useSendSingleBypassZone,
} from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { useEffect, useState } from 'react';
import CardComponent from '../../../../../components/CardComponent/CardComponent';
import { IAlarmCentralVettiStatusProps } from '../../../../../services/AlarmCentralService/Physical/Vetti/types';

interface AlarmCentralPhysicalVettiZonesProps {
  alarmCentral: IAlarmCentralProps;
  status: IAlarmCentralVettiStatusProps;
}

const AlarmCentralPhysicalVettiZones = ({
  alarmCentral,
  status,
}: AlarmCentralPhysicalVettiZonesProps) => {
  const {
    mutateAsync: mutateSendBypassZonesAsync,
    isLoading: isLoadingSendBypassZonesAsync,
  } = useSendSingleBypassZone();
  const [isLoadingZone, setIsLoadingZone] = useState<boolean[]>([]);

  const createZoneListToUpdate = (zoneIndexToUpdate: number) => {
    const zones: IZoneAlarmCentralProps[] = [];
    status.isBypassZones.forEach((isBypass, index) => {
      if (zoneIndexToUpdate == index) {
        zones.push({
          bypass: !isBypass,
          zoneCode: index + 1,
        });
      } else {
        zones.push({
          bypass: isBypass,
          zoneCode: index + 1,
        });
      }
    });
    return zones;
  };

  // const inhibitedMessage = (zoneStatus: ZoneStatusVetti) => {
  //   return zoneStatus === ZoneStatusVetti.DISABLED
  //     ? ''
  //     : zoneStatus === ZoneStatusVetti.INHIBITED
  //       ? 'Clique para remover inibição'
  //       : 'Clique para inibir';
  // };

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.zoneQuantity; i++) isLoading.push(false);

    setIsLoadingZone(isLoading);
  }, [status, alarmCentral]);

  return (
    <>
      {[...Array(alarmCentral.zoneQuantity)].map((z, index) => {
        // const zoneStatus = status.zonesStatus[index];
        // const zoneColor =
        //   zoneStatus === ZoneStatusVetti.CLOSED
        //     ? 'red'
        //     : zoneStatus === ZoneStatusVetti.OPEN
        //       ? 'green'
        //       : zoneStatus === ZoneStatusVetti.INHIBITED
        //         ? '#fff'
        //         : 'rgb(47, 57, 87)';

        return (
          <Grid2 key={index} size={{ md: 4, xs: 12 }}>
            <CardComponent
              // disabled={zoneStatus === ZoneStatusVetti.DISABLED}
              isLoading={isLoadingZone[index]}
              onClick={() => {
                mutateSendBypassZonesAsync({
                  endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_VETTI_ENDPOINT,
                  id: alarmCentral.id,
                  zone: index + 1,
                });
                const isl = [...isLoadingZone];
                isl[index] = true;
                setIsLoadingZone(isl);
              }}
              additionalMessage={status.isBypassZones[index] && 'Inibida'}
              // representativeColor={}
              // tooltipMessage={inhibitedMessage(zoneStatus)}
            >
              <Typography sx={{ fontWeight: 'bold' }}>
                ZONA {index + 1}
              </Typography>
            </CardComponent>
          </Grid2>
        );
      })}
    </>
  );
};

export default AlarmCentralPhysicalVettiZones;
